import { SwissGermanLocale, SwissTimeZone } from '../../../data/constants';
import { Typography } from '@material-ui/core';
import React from 'react';
import { GetTranslation } from '../../../translations/GetTranslation';
import { useIntl } from 'react-intl';

type VariantType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "srOnly" | "inherit" | undefined;

type LocaleFormatDateProps = {
  date: Date;
  variant?: VariantType;
  className?: string;
  showTime?: boolean;
};

const LocaleFormatDate: React.FunctionComponent<LocaleFormatDateProps> = ({ date, className, variant, showTime = false }) => {
  const intl = useIntl();
  const d = new Date(date);

  return (<Typography className={className} variant={variant} display="inline" component="span">
    {d.getFullYear() === 1
      ? GetTranslation(intl, "common.Unknown")
      : showTime 
        ? d.toLocaleString(SwissGermanLocale, { timeZone: SwissTimeZone })
        : d.toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })}
  </Typography>);
};

LocaleFormatDate.defaultProps = {
    variant: 'h6',
} as Partial<LocaleFormatDateProps>;

export default LocaleFormatDate;